/* eslint-disable @next/next/no-img-element */
import { useAuth } from "@/contexts/Auth";
import { useGlobalData } from "@/contexts/GlobalData";
import useFetchApi from "@/hook/useFetch";
import useGetSettingDepositAndWithdraw from "@/hook/useGetSettingDepositAndWithdraw";
import { cn } from "@/lib/utils";
import depositWithSubPaymentService from "@/services/payment/depositWithSubPaymentService";
import getEstFeeWithSubPayment from "@/services/payment/getEstFeeWithSubPayment";
import getIcon from "@/utils/getIcon";
import { Modal, ModalContent, Skeleton, useDisclosure } from "@nextui-org/react";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import DynamicFontSize from "../DynamicFontSize";
import DynamicSizeIcon from "../DynamicSizeIcon";
import FeesBlock from "../FeesBlock";
import FormatterNumber from "../FormatterNumber";
import Input from "../Input";
import LeftGradientBorder from "../LeftGradientBorder";
import LineContentValue from "../LineContentValue";
import Menu, { useMenu } from "../Menu";
import MenuItem from "../MenuItem";
import MenuLayout from "../MenuLayout";
import ModalLayout from "../ModalLayout";
import PrimaryButton, { ButtonStatus } from "../PrimaryButton";
import TransferWithSubPaymentGateway from "../TransferWithSubPaymentGateway";
import formatDateDistance from "@/common/function/formatDateDistance";
import TokenRateLifeTime from "../TokenRateLifeTime";
import { usePocketBaseData } from "@/contexts/Pocketbase";
import { TRANSACTION_TYPE } from "@/common/const";
import SubPaymentWarning from "../SubPaymentWarning";
import UnderlineText from "../UnderlineText";
import SubPaymentFeeInfo, { Fee } from "../SubPaymentFeeInfo";
import { Keyboard, KeyboardType, DisplayType, KeyboardRef, THEME, Input as TekInput, InputRef } from "tek-input-keyboard";
type FiatDepositInput = {
  children?: React.ReactNode;
  classNameChildren?: string;
  prefixFromParent?: string;
  selectedToken?: any;
  handleOpenTokens?: () => void;
  onClosePaymentOptions?(): void;
  switchToDepositTBKWallet?: () => void;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
};
function FiatDepositInput({
  children,
  classNameChildren,
  prefixFromParent,
  handleOpenTokens,
  selectedToken,
  onClosePaymentOptions,
  switchToDepositTBKWallet,
  isOpen,
  onOpen,
  onClose
}: FiatDepositInput) {
  const {
    isOpen: isComfirmOpen,
    onOpen: onOpenComfirm,
    onOpenChange: onOpenChangeComfirm,
    onClose: onCloseComfirm
  } = useDisclosure();
  const {
    isOpen: isQrOpen,
    onOpen: onOpenOrOpen,
    onOpenChange: onOpenChangeOrOpen,
    onClose: onCloseOrOpen
  } = useDisclosure();
  const convertValue = 1;
  const {
    translate,
    getImageFromCMS,
    userInfo,
    havePendingTransaction,
    subPaymentFeeData,
    deviceInfo
  } = useGlobalData();
  const {
    triggerTransaction
  } = usePocketBaseData();
  const {
    teleId
  } = useAuth();
  const [activityTypeFilter, toggleActivityTypeFilter] = useMenu();
  const [isSwitchInput, setIsSwitchInput] = useState<boolean>(true);
  const [estFeeStatus, setEstFeeStatus] = useState<ButtonStatus>("normal");
  const [invalid, setInvalid] = useState<string>("");
  const [amount, setAmount] = useState("");
  const [valueRange, setValueRange] = useState(0);
  const [subPaymentFees, setSubPaymentFees] = useState<any>();
  const {
    data: settingDepositAndWithdraw,
    error,
    loading
  } = useGetSettingDepositAndWithdraw();
  const {
    buttonLoading,
    data: result,
    fetchData: depositWithSubPayment
  } = useFetchApi(depositWithSubPaymentService);
  const switchInput = () => {
    setIsSwitchInput(!isSwitchInput);
  };
  const handleCloseTransferWithSubPaymentGateway = () => {
    onCloseOrOpen();
    onCloseComfirm();
    onClose();
    onClosePaymentOptions?.();
    handleClear();
  };
  const handleClear = () => {
    setInvalid("");
    setValueRange(0);
    setAmount("");
    // keyboardRef.current?.close();
  };
  const handleEstFee = () => {
    setEstFeeStatus("loading");
    const rateVnd = settingDepositAndWithdraw?.rateTokens?.["VND"].USD;
    const convertedAmount = !isSwitchInput ? Number(amount) * settingDepositAndWithdraw?.rateTokens?.[selectedToken?.currency_name].USD / rateVnd : Number(amount);
    try {
      getEstFeeWithSubPayment({
        amount: convertedAmount,
        currency: "VND",
        paymentGateway: "aipay",
        paymentMethod: "visa"
      }, responseData => {
        const settingFee = responseData.fee.map((f: any) => {
          return {
            fee_type: {
              name: f.feeName,
              key: f.feeName
            },
            currency: {
              symbol: responseData.originalCurrency
            },
            fixed: f.feeAmountInOriginalCurrency,
            percent: 0
          };
        });
        const finalFee = Number(responseData.totalFeeAmountInOriginalCurrency) * rateVnd / settingDepositAndWithdraw?.rateTokens?.[selectedToken?.currency_name].USD;
        setSubPaymentFees({
          feeIn: true,
          feeNetwork: 0,
          finalFee,
          settingFee,
          totalFeeAmountInOriginalCurrency: responseData.totalFeeAmountInOriginalCurrency,
          secondsTimeout: responseData.secondsTimeout
        });
        setEstFeeStatus("success");
        setTimeout(() => {
          setEstFeeStatus("normal");
        }, 1500);
        onOpenComfirm();
        onClose();
      }, error => {
        console.log(error, "error");
        setEstFeeStatus("error");
        setTimeout(() => {
          setEstFeeStatus("normal");
        }, 1500);
      });
    } catch (error) {
      console.error(error);
      setEstFeeStatus("loading");
    }
  };
  const handleDeposit = (amount: number) => {
    depositWithSubPayment({
      amount,
      currency: "VND",
      slugCurrencyConvert: selectedToken.slug,
      username: userInfo.username,
      telegramId: teleId
    }, () => {
      onOpenOrOpen();
    });
  };
  const amountByRate = useMemo(() => {
    if (!settingDepositAndWithdraw || !selectedToken || !amount) return 0;
    if (isSwitchInput) {
      return Number(amount) * settingDepositAndWithdraw?.rateTokens?.["VND"].USD / settingDepositAndWithdraw?.rateTokens?.[selectedToken?.currency_name].USD;
    } else {
      return Number(amount) * settingDepositAndWithdraw?.rateTokens?.[selectedToken?.currency_name].USD / settingDepositAndWithdraw?.rateTokens?.["VND"].USD;
    }
  }, [settingDepositAndWithdraw, isSwitchInput, selectedToken, amount]);
  const convertEstimate = useMemo(() => {
    if (!settingDepositAndWithdraw || !selectedToken) return 0;
    return convertValue * settingDepositAndWithdraw?.rateTokens?.[selectedToken?.currency_name].USD / settingDepositAndWithdraw?.rateTokens?.["VND"].USD;
  }, [settingDepositAndWithdraw, isSwitchInput, selectedToken, amount]);
  const freeFeesTime = useMemo(() => {
    return subPaymentFeeData?.filter((item: Fee) => !item?.feePercent && !item?.feeFix);
  }, [subPaymentFeeData]);
  const availableFreeFee = useMemo(() => {
    const index = freeFeesTime?.findIndex((item: Fee) => item?.isCurrent);
    if (index === -1) return [];
    return freeFeesTime?.slice(index);
  }, [freeFeesTime]);
  useEffect(() => {
    if (!settingDepositAndWithdraw || !amount || !selectedToken) return;
    const foundConfigByToken = settingDepositAndWithdraw?.config?.find((config: any) => config?.currency?.slug == selectedToken?.slug);
    if (!foundConfigByToken) {
      return setInvalid("Invalid token");
    }
    let amountInput = 0;
    if (isSwitchInput) {
      amountInput = Number(amount) * settingDepositAndWithdraw?.rateTokens?.["VND"].USD / settingDepositAndWithdraw?.rateTokens?.["USD"].USD;
    } else {
      amountInput = Number(amount) * settingDepositAndWithdraw?.rateTokens?.[selectedToken?.currency_name].USD / settingDepositAndWithdraw?.rateTokens?.["USD"].USD;
    }
    if (amountInput < foundConfigByToken?.min_balance_deposit * settingDepositAndWithdraw?.rateTokens?.[selectedToken?.currency_name].USD) {
      setValueRange(foundConfigByToken?.min_balance_deposit);
      setInvalid("min_balance_deposit");
      return;
    }
    if (amountInput > foundConfigByToken?.max_balance_deposit * settingDepositAndWithdraw?.rateTokens?.[selectedToken?.currency_name].USD) {
      setValueRange(foundConfigByToken?.max_balance_deposit);
      setInvalid("max_balance_deposit");
      return;
    }
    setValueRange(0);
    setInvalid("");
  }, [amount, settingDepositAndWithdraw, selectedToken, isSwitchInput]);
  useEffect(() => {
    setTimeout(() => document.getElementById("deposit_amount_label")?.click(), 100);
    return handleClear;
  }, []);
  useEffect(() => {
    if (!result || !triggerTransaction) return;
    if (!triggerTransaction?.record?.code || triggerTransaction?.record?.transaction_type != TRANSACTION_TYPE.DEPOSIT) return;
    if (triggerTransaction?.record?.status != "success") return;
    if (triggerTransaction?.record?.id == result?.data?.noti?.id) {
      handleCloseTransferWithSubPaymentGateway();
      handleClear();
    }
  }, [triggerTransaction, result]);
  const handleOpen = () => {
    onOpen();
    keyboardRef.current?.open();
  };
  const keyboardRef = useRef<KeyboardRef>(null);
  const inputRef = useRef<InputRef>(null);
  const _onChange = (value: string) => {
    setAmount(Number(value).toString());
  };
  return <Fragment>
            <SubPaymentWarning conditionOpen={havePendingTransaction} handleNext={handleOpen} data-sentry-element="SubPaymentWarning" data-sentry-source-file="index.tsx">
                <div className={cn("cursor-pointer", classNameChildren)} onClick={!havePendingTransaction ? handleOpen : undefined}>
                    {children}
                </div>
            </SubPaymentWarning>

            {/* <Modal
                isOpen={isOpen}
                placement="bottom"
                onOpenChange={onOpenChange}
                isDismissable={false}
                hideCloseButton
                backdrop="blur"
             >
                <ModalContent className="rounded-none bg-transparent !mx-0 !my-0 !max-w-[100vw]">
                    {isOpen && <Keyboard
                        toolbar={
                            <ModalLayout
                                modalKey="830ce6bc-486e-4e55-8474-b1c54670fg15d0edwdfhf"
                                title={translate(prefixFromParent + "deposit")}
                                onClose={() => {
                                    onClose();
                                    handleClear();
                                }}
                                className="!z-10 !min-h-0"
                            >
                                <div className="flex flex-col justify-center gap-4">
                                    <div className="flex flex-col gap-3">
                                        <label
                                            htmlFor="deposit_amount"
                                            id="deposit_amount_label"
                                            aria-label="deposit_amount"
                                        >
                                            <DynamicFontSize fontSize={13} className="font-medium text-description">
                                                {translate(prefixFromParent + "you pay")}
                                            </DynamicFontSize>
                                        </label>
                                        <Input
                                            autoComplete="off"
                                            autoFocus
                                            name="deposit_amount"
                                            id="deposit_amount"
                                            showClearButton={false}
                                            inputMode="decimal"
                                            readOnly={isMobile}
                                            // className="border-0 !bg-transparent !p-0"
                                            borderGradient
                                            isShowMaxButton={false}
                                            placeholder={translate(prefixFromParent + "enter amount")}
                                            valueFromParent={amount}
                                            onAmountChange={setAmount}
                                            rightPart={
                                                isSwitchInput ? (
                                                    <div className="flex items-center gap-1.5">
                                                        <DynamicSizeIcon
                                                            width={24}
                                                            height={24}
                                                            icon={getImageFromCMS("vietnam")}
                                                        />
                                                        <DynamicFontSize
                                                            fontSize={16}
                                                            className="font-medium text-description"
                                                        >
                                                            VND
                                                        </DynamicFontSize>
                                                    </div>
                                                ) : (
                                                    <DynamicFontSize
                                                        onClick={handleOpenTokens}
                                                        fontSize={13}
                                                        className="text-[#fff] font-semibold leading-[140%] flex items-center gap-1.5 uppercase"
                                                    >
                                                        <DynamicSizeIcon
                                                            icon={selectedToken?.logo?.url}
                                                            width={24}
                                                            height={24}
                                                        />
                                                        {selectedToken?.currency_name}
                                                        <DynamicSizeIcon
                                                            icon={getIcon("arrow_accordion")}
                                                            width={11}
                                                            className={cn(
                                                                "duration-300",
                                                                activityTypeFilter ? "rotate-0" : "rotate-180"
                                                            )}
                                                        />
                                                    </DynamicFontSize>
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="flex flex-col gap-3">
                                        <DynamicFontSize fontSize={13} className="font-medium text-description">
                                            {translate(prefixFromParent + "you receive")}
                                        </DynamicFontSize>
                                        <LeftGradientBorder
                                            className="p-4 rounded-[20px] flex flex-col gap-4"
                                            background="green_rotate_border_fiat"
                                        >
                                            <div className="w-full flex items-center gap-2 relative">
                                                <Skeleton
                                                    isLoaded={!loading}
                                                    className="w-fit mx-auto bg-default/10 before:opacity-20 rounded-md"
                                                >
                                                    <DynamicFontSize fontSize={13} className="text-white capitalize">
                                                        {settingDepositAndWithdraw?.rateTokens["VND"].source}
                                                    </DynamicFontSize>
                                                </Skeleton>
                                                <div className="dashed-divider flex-1"></div>
                                                <Skeleton
                                                    isLoaded={!loading}
                                                    className="w-fit mx-auto bg-default/10 before:opacity-20 rounded-md"
                                                >
                                                    <div className="flex flex-col items-end gap-0.5">
                                                        <div className="flex items-center gap-1 relative">
                                                            <DynamicFontSize
                                                                className="text-white font-medium text-center"
                                                                fontSize={12}
                                                            >
                                                                <FormatterNumber
                                                                    value={convertValue}
                                                                    isLessThan
                                                                    unit={` ${selectedToken?.currency_name}`}
                                                                />{" "}
                                                                ~{" "}
                                                                <FormatterNumber
                                                                    value={convertEstimate}
                                                                    isLessThan
                                                                    unit=" VND"
                                                                />
                                                            </DynamicFontSize>
                                                            <TokenRateLifeTime className="size-4" />
                                                        </div>
                                                    </div>
                                                </Skeleton>
                                            </div>
                                            <LineContentValue
                                                field={
                                                    <DynamicFontSize
                                                        fontSize={18}
                                                        className="font-semibold text-success"
                                                    >
                                                        <FormatterNumber
                                                            value={amountByRate}
                                                            isLessThan
                                                            useCompact={false}
                                                        />
                                                    </DynamicFontSize>
                                                }
                                                value={
                                                    !isSwitchInput ? (
                                                        <div className="flex items-center gap-1.5">
                                                            <DynamicSizeIcon
                                                                width={24}
                                                                height={24}
                                                                icon={getImageFromCMS("vietnam")}
                                                            />
                                                            <DynamicFontSize
                                                                fontSize={16}
                                                                className="font-medium text-description"
                                                            >
                                                                VND
                                                            </DynamicFontSize>
                                                        </div>
                                                    ) : (
                                                        <DynamicFontSize
                                                            onClick={handleOpenTokens}
                                                            fontSize={13}
                                                            className="text-[#fff] font-semibold leading-[140%] flex items-center gap-1.5 uppercase"
                                                        >
                                                            <DynamicSizeIcon
                                                                icon={selectedToken?.logo?.url}
                                                                width={24}
                                                                height={24}
                                                            />
                                                            {selectedToken?.currency_name}
                                                            <DynamicSizeIcon
                                                                icon={getIcon("arrow_accordion")}
                                                                width={11}
                                                                className={cn(
                                                                    "duration-300",
                                                                    activityTypeFilter ? "rotate-0" : "rotate-180"
                                                                )}
                                                            />
                                                        </DynamicFontSize>
                                                    )
                                                }
                                            />
                                            {invalid && valueRange && (
                                                <DynamicFontSize className="text-error font-medium" fontSize={12}>
                                                    {translate(invalid + "before")}
                                                    <FormatterNumber
                                                        value={
                                                            isSwitchInput
                                                                ? (valueRange /
                                                                      settingDepositAndWithdraw?.rateTokens?.["VND"]
                                                                          .USD) *
                                                                  settingDepositAndWithdraw?.rateTokens?.[
                                                                      selectedToken?.currency_name
                                                                  ].USD
                                                                : valueRange
                                                        }
                                                        unit={
                                                            isSwitchInput ? " VND" : ` ${selectedToken?.currency_name}`
                                                        }
                                                        useCompact={false}
                                                    />
                                                    {translate(invalid + "after")}
                                                </DynamicFontSize>
                                            )}
                                        </LeftGradientBorder>
                                    </div>
                                    <PrimaryButton
                                        onClick={handleEstFee}
                                        status={!amount || invalid ? "disabled" : estFeeStatus}
                                        statusKey={prefixFromParent + "sub payment"}
                                    />
                                </div>
                            </ModalLayout>
                        }
                        theme={THEME.DARK}
                        onChange={_onChange}
                        ref={keyboardRef}
                        openInit
                        keyboardId="key-board"
                        alwaysOpen
                    /> }
                </ModalContent>
             </Modal> */}

            {isOpen && <Keyboard keyboardId="fiat-deposit" toolbar={<ModalLayout modalKey="830ce6bc-486e-4e55-8474-b1c54670fg15d0edwdfhf" title={translate(prefixFromParent + "deposit")} onClose={() => {
      onClose();
      handleClear();
    }} className="!z-10 !min-h-0 " boxClassName="pb-4 rounded-b-none">
                            <div className="flex flex-col justify-center gap-4">
                                <div className="flex flex-col gap-3">
                                    <label htmlFor="deposit_amount" id="deposit_amount_label" aria-label="deposit_amount">
                                        <DynamicFontSize fontSize={13} className="font-medium text-description">
                                            {translate(prefixFromParent + "you pay")}
                                        </DynamicFontSize>
                                    </label>
                                    <TekInput isUseFormatNumber elementsAcceptIds={["fiat-deposit"]} autoFocus value={amount} classNames={{
            container: "border_gradient bg-white/[0.16] border-none z-10"
          }} theme={THEME.DARK} ref={inputRef} rightElement={isSwitchInput ? <div className="flex items-center gap-1.5">
                                                    <DynamicSizeIcon width={24} height={24} icon={getImageFromCMS("vietnam")} />
                                                    <DynamicFontSize fontSize={16} className="font-medium text-description">
                                                        VND
                                                    </DynamicFontSize>
                                                </div> : <DynamicFontSize onClick={() => {
            handleOpenTokens?.();
            onClose();
          }} fontSize={13} className="text-[#fff] font-semibold leading-[140%] flex items-center gap-1.5 uppercase">
                                                    <DynamicSizeIcon icon={selectedToken?.logo?.url} width={24} height={24} />
                                                    {selectedToken?.currency_name}
                                                    <DynamicSizeIcon icon={getIcon("arrow_accordion")} width={11} className={cn("duration-300", activityTypeFilter ? "rotate-0" : "rotate-180")} />
                                                </DynamicFontSize>} />
                                    {/* <Input
                                        autoComplete="off"
                                        autoFocus
                                        name="deposit_amount"
                                        id="deposit_amount"
                                        showClearButton={false}
                                        inputMode="decimal"
                                        readOnly
                                        borderGradient
                                        isShowMaxButton={false}
                                        placeholder={translate(prefixFromParent + "enter amount")}
                                        valueFromParent={amount}
                                        onAmountChange={setAmount}
                                        rightPart={
                                            isSwitchInput ? (
                                                <div className="flex items-center gap-1.5">
                                                    <DynamicSizeIcon
                                                        width={24}
                                                        height={24}
                                                        icon={getImageFromCMS("vietnam")}
                                                    />
                                                    <DynamicFontSize
                                                        fontSize={16}
                                                        className="font-medium text-description"
                                                    >
                                                        VND
                                                    </DynamicFontSize>
                                                </div>
                                            ) : (
                                                <DynamicFontSize
                                                    onClick={handleOpenTokens}
                                                    fontSize={13}
                                                    className="text-[#fff] font-semibold leading-[140%] flex items-center gap-1.5 uppercase"
                                                >
                                                    <DynamicSizeIcon
                                                        icon={selectedToken?.logo?.url}
                                                        width={24}
                                                        height={24}
                                                    />
                                                    {selectedToken?.currency_name}
                                                    <DynamicSizeIcon
                                                        icon={getIcon("arrow_accordion")}
                                                        width={11}
                                                        className={cn(
                                                            "duration-300",
                                                            activityTypeFilter ? "rotate-0" : "rotate-180"
                                                        )}
                                                    />
                                                </DynamicFontSize>
                                            )
                                        }
                                     /> */}
                                </div>
                                <div className="flex flex-col gap-3">
                                    <DynamicFontSize fontSize={13} className="font-medium text-description">
                                        {translate(prefixFromParent + "you receive")}
                                    </DynamicFontSize>
                                    <LeftGradientBorder className="p-4 rounded-[20px] flex flex-col gap-4" background="green_rotate_border_fiat">
                                        <div className="w-full flex items-center gap-2 relative">
                                            <Skeleton isLoaded={!loading} className="w-fit mx-auto bg-default/10 before:opacity-20 rounded-md">
                                                <DynamicFontSize fontSize={13} className="text-white capitalize">
                                                    {settingDepositAndWithdraw?.rateTokens["VND"].source}
                                                </DynamicFontSize>
                                            </Skeleton>
                                            <div className="dashed-divider flex-1"></div>
                                            <Skeleton isLoaded={!loading} className="w-fit mx-auto bg-default/10 before:opacity-20 rounded-md">
                                                <div className="flex flex-col items-end gap-0.5">
                                                    <div className="flex items-center gap-1 relative">
                                                        <DynamicFontSize className="text-white font-medium text-center" fontSize={12}>
                                                            <FormatterNumber value={convertValue} isLessThan unit={` ${selectedToken?.currency_name}`} />{" "}
                                                            ~{" "}
                                                            <FormatterNumber value={convertEstimate} isLessThan unit=" VND" />
                                                        </DynamicFontSize>
                                                        <TokenRateLifeTime className="size-4" />
                                                    </div>
                                                </div>
                                            </Skeleton>
                                        </div>
                                        <LineContentValue field={<DynamicFontSize fontSize={18} className="font-semibold text-success">
                                                    <FormatterNumber value={amountByRate} isLessThan useCompact={false} />
                                                </DynamicFontSize>} value={!isSwitchInput ? <div className="flex items-center gap-1.5">
                                                        <DynamicSizeIcon width={24} height={24} icon={getImageFromCMS("vietnam")} />
                                                        <DynamicFontSize fontSize={16} className="font-medium text-description">
                                                            VND
                                                        </DynamicFontSize>
                                                    </div> : <DynamicFontSize onClick={() => {
              handleOpenTokens?.();
              onClose();
            }} fontSize={13} className="text-[#fff] font-semibold leading-[140%] flex items-center gap-1.5 uppercase">
                                                        <DynamicSizeIcon icon={selectedToken?.logo?.url} width={24} height={24} />
                                                        {selectedToken?.currency_name}
                                                        <DynamicSizeIcon icon={getIcon("arrow_accordion")} width={11} className={cn("duration-300", activityTypeFilter ? "rotate-0" : "rotate-180")} />
                                                    </DynamicFontSize>} />
                                        {invalid && valueRange && <DynamicFontSize className="text-error font-medium" fontSize={12}>
                                                {translate(invalid + "before")}
                                                <FormatterNumber value={isSwitchInput ? valueRange / settingDepositAndWithdraw?.rateTokens?.["VND"].USD * settingDepositAndWithdraw?.rateTokens?.[selectedToken?.currency_name].USD : valueRange} unit={isSwitchInput ? " VND" : ` ${selectedToken?.currency_name}`} useCompact={false} />
                                                {translate(invalid + "after")}
                                            </DynamicFontSize>}
                                    </LeftGradientBorder>
                                </div>
                                <PrimaryButton onClick={handleEstFee} status={!amount || invalid ? "disabled" : estFeeStatus} statusKey={prefixFromParent + "sub payment"} />
                            </div>
                        </ModalLayout>} theme={THEME.DARK} onChange={_onChange} ref={keyboardRef} alwaysOpen value={amount} />}
            <Modal isOpen={isComfirmOpen} placement="bottom" onOpenChange={onOpenChangeComfirm} isDismissable={false} hideCloseButton backdrop="blur" data-sentry-element="Modal" data-sentry-source-file="index.tsx">
                <ModalContent className="rounded-none bg-transparent !mx-0 !my-0 !max-w-[100vw] !z-[999999]" data-sentry-element="ModalContent" data-sentry-source-file="index.tsx">
                    <ModalLayout modalKey="830ce6bc-486e-4e55-8474-b1c54670fg15d0edwdfhf" title={translate(prefixFromParent + "deposit")} onClose={() => {
          onCloseComfirm();
          onOpen();
        }} boxClassName="!z-[999999]" childrenClassName="!z-[999999]" data-sentry-element="ModalLayout" data-sentry-source-file="index.tsx">
                        <div className="flex flex-col justify-center gap-4 text-white ">
                            <div className="flex flex-col gap-1 items-center">
                                <DynamicFontSize fontSize={14} className="font-medium text-white" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                                    {translate(prefixFromParent + "You will receive")}
                                </DynamicFontSize>
                                <DynamicFontSize fontSize={32} className="font-medium text-success" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                                    +
                                    <FormatterNumber value={!isSwitchInput ? Number(amount) : amountByRate} unit={` ${selectedToken?.currency_name}`} unitCustomStyle="text-lg font-light" useCompact={false} data-sentry-element="FormatterNumber" data-sentry-source-file="index.tsx" />
                                </DynamicFontSize>
                                <Skeleton isLoaded={!loading} className="w-fit mx-auto bg-default/10 before:opacity-20 rounded-md" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx">
                                    <div className="flex items-center gap-1.5">
                                        <DynamicFontSize className="text-white font-medium text-center" fontSize={12} data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                                            {convertValue} {selectedToken?.currency_name} ~{" "}
                                            <FormatterNumber value={convertEstimate} isLessThan unit={` VND`} data-sentry-element="FormatterNumber" data-sentry-source-file="index.tsx" />
                                        </DynamicFontSize>
                                        <TokenRateLifeTime data-sentry-element="TokenRateLifeTime" data-sentry-source-file="index.tsx" />
                                    </div>
                                </Skeleton>
                            </div>
                            <LeftGradientBorder className="p-4 rounded-[20px] flex flex-col gap-3" background="vision_light" data-sentry-element="LeftGradientBorder" data-sentry-source-file="index.tsx">
                                <LineContentValue field={<DynamicFontSize fontSize={14} className=" text-white">
                                            {translate(prefixFromParent + "order amount")}
                                        </DynamicFontSize>} value={<DynamicFontSize fontSize={15} className="font-medium text-white">
                                            <FormatterNumber value={!isSwitchInput ? amountByRate : Number(amount)} isLessThan unit=" VND" useCompact={false} />
                                        </DynamicFontSize>} data-sentry-element="LineContentValue" data-sentry-source-file="index.tsx" />

                                <LineContentValue field={<DynamicFontSize fontSize={14} className=" text-white">
                                            {translate(prefixFromParent + "action")}
                                        </DynamicFontSize>} value={<div className="flex items-center gap-1">
                                            <DynamicSizeIcon icon={selectedToken?.logo?.url} width={16} height={16} />
                                            <DynamicFontSize fontSize={15} className="font-medium text-white">
                                                {translate(prefixFromParent + "buy") + selectedToken?.currency_name}
                                            </DynamicFontSize>
                                        </div>} data-sentry-element="LineContentValue" data-sentry-source-file="index.tsx" />
                                <LineContentValue field={<DynamicFontSize fontSize={14} className=" text-white">
                                            {translate(prefixFromParent + "bank transfer time")}
                                        </DynamicFontSize>} value={<DynamicFontSize fontSize={15} className="font-medium text-white">
                                            {subPaymentFees?.secondsTimeout && `${formatDateDistance(new Date(new Date().getTime() + Number(subPaymentFees?.secondsTimeout) * 1000).toString(), false, true)} ${translate(prefixFromParent + "transfer time unit")}`}
                                        </DynamicFontSize>} data-sentry-element="LineContentValue" data-sentry-source-file="index.tsx" />
                            </LeftGradientBorder>
                            <FeesBlock
            // currency={selectedToken?.currency_name}
            fees={subPaymentFees} validBalance={{
              all: true,
              VND: true
            }} prefix={prefixFromParent} amount={!isSwitchInput ? amountByRate : amountByRate * settingDepositAndWithdraw?.rateTokens?.["VND"].USD} loadingFees={estFeeStatus != "normal"} background="opacity_black" compact={false} isFree={availableFreeFee?.length > 0} data-sentry-element="FeesBlock" data-sentry-source-file="index.tsx">
                                <SubPaymentFeeInfo data-sentry-element="SubPaymentFeeInfo" data-sentry-source-file="index.tsx"></SubPaymentFeeInfo>
                            </FeesBlock>
                            <LineContentValue field={<DynamicFontSize fontSize={13} className="font-medium text-white">
                                        {translate("total pay")}
                                    </DynamicFontSize>} value={<DynamicFontSize fontSize={17} className="font-semibold text-error ">
                                        <FormatterNumber value={(!isSwitchInput ? amountByRate : Number(amount)) + subPaymentFees?.totalFeeAmountInOriginalCurrency} isLessThan unit=" VND" unitCustomStyle="text-sm text-error-5" useCompact={false} />
                                    </DynamicFontSize>} data-sentry-element="LineContentValue" data-sentry-source-file="index.tsx" />
                            <div className="dashed-divider w-full"></div>
                            <DynamicFontSize fontSize={12} className="italic text-description" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                                {translate(prefixFromParent + "sub payment gw desc before")}
                                <UnderlineText onClick={() => {
                switchToDepositTBKWallet?.();
                handleCloseTransferWithSubPaymentGateway();
              }} data-sentry-element="UnderlineText" data-sentry-source-file="index.tsx">
                                    {translate(prefixFromParent + "tbk wallet")}
                                </UnderlineText>
                                {translate(prefixFromParent + "sub payment gw desc after")}
                            </DynamicFontSize>
                            <PrimaryButton onClick={() => {
              handleDeposit(!isSwitchInput ? amountByRate : Number(amount));
            }} status={!amount || invalid ? "disabled" : buttonLoading} statusKey={prefixFromParent + "continue"} data-sentry-element="PrimaryButton" data-sentry-source-file="index.tsx" />
                        </div>
                    </ModalLayout>
                </ModalContent>
            </Modal>
            <TransferWithSubPaymentGateway isQrOpen={isQrOpen} onCloseOrOpen={handleCloseTransferWithSubPaymentGateway} transferData={result?.data} prefixFromParent={prefixFromParent} onOpenChangeOrOpen={onOpenChangeOrOpen} data-sentry-element="TransferWithSubPaymentGateway" data-sentry-source-file="index.tsx" />
        </Fragment>;
}
export default FiatDepositInput;